module.exports = __webpack_public_path__ + "static/kapelanka-pychowicka-e834fb3657af3febbeb9e088ea011f15.png";